/**
 * OrbDocCoreConceptsEntitiesSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsEntitiesSLDocScreen
 */

import { useOrbDocCoreConceptsEntitiesSLDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsEntitiesSLDocScreenLogic';
import type { OrbDocCoreConceptsEntitiesSLDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsEntitiesSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsEntitiesSLDocView as OrbDocCoreConceptsEntitiesSLDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsEntitiesSLDocBodyView } from '@/components/traits/OrbDocCoreConceptsEntitiesSLDocBodyView';
import { OrbDocCoreConceptsEntitiesSLDocFooterView } from '@/components/traits/OrbDocCoreConceptsEntitiesSLDocFooterView';
import { OrbDocCoreConceptsEntitiesSLDocHeaderView } from '@/components/traits/OrbDocCoreConceptsEntitiesSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsEntitiesSLDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsEntitiesSLDocScreenConfig>;
}

export function OrbDocCoreConceptsEntitiesSLDocScreenView({ config: propsConfig }: OrbDocCoreConceptsEntitiesSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsEntitiesSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsEntitiesSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsEntitiesSL" trait="OrbDocCoreConceptsEntitiesSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsEntitiesSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsEntitiesSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsEntitiesSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsEntitiesSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsEntitiesSLDocScreenView;
